if (customElements.get('store-switcher') === undefined) {
  class StoreSwitcher extends HTMLElement {
    
    constructor() {
      super();
    }
  
    static get observedAttributes() {
      return ['open'];
    }
  
    connectedCallback() {

      this.data = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      this.stores = this.data.stores;
      //Check Url for redirect parameter
      this.checkSelection();
      //Listener for keypress ESC key closes modal
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      //Listener for click on modal background closes modal
      this.querySelector('.modal-dialog__background').addEventListener('click', (event) => {
        this.hide();
      });

      this.close = this.querySelector('[name="close"]');
      this.close.addEventListener('click', this.hide.bind(this));

      //Check if we are in design mode, if so, do not run the script
      if(Shopify.designMode) return;
      //Check if cookie exists and auto is true, call checkLocation to determine if popup should be shown
      if(this.getCookie('store-selected') == null && this.dataset.auto === 'true') this.checkLocation();
    }
  
    disconnectedCallback() {
    }
  
    attributeChangedCallback(name, oldVal, newVal) {
      if(name == 'open') {
        if(this.open) {
          this.querySelector('[name="close"]').focus();
          document.body.classList.add('no-scroll');
        }else{
          document.body.classList.remove('no-scroll');
        }
      }
    }
  
    adoptedCallback() {
    }

    setCookie(cName, cValue, expDays) {
      let date = new Date();
      date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = cName + "=" + cValue + "; " + expires + ";path=/;";
    }

    getCookie(name) {
      let value = "; " + document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    }

    checkSelection() { 
      const params = new URL(window.location.href).searchParams;
      const store = params.get('store-selected');
      if(store){
        this.setCookie('store-selected', 'true', 90); 
      }
    }

    async checkLocation(){
      //Get location data
      const location = await this.getLocation();
      //Show popup if location is not in the current store
      const store = this.stores.find((store) => store.country_codes.includes(location.detected_values.country.handle));
      if(Shopify.country !== location.detected_values.country.handle){
        this.show();
      }
    }

    async getLocation() {
      const response = await fetch(
        window.Shopify.routes.root
          + 'browsing_context_suggestions.json'
          + '?country[enabled]=true'
          + `&country[exclude]=${window.Shopify.country}`
          + '&language[enabled]=true'
          + `&language[exclude]=${window.Shopify.language}`
      );
      const data = await response.json();
      return data;
    }
  
    show() {
      if(this.hasAttribute('hidden')){ 
        this.removeAttribute('hidden'); 
      }
      this.open = true;
    }
  
    hide() {
      this.open = false;
      this.setCookie('store-selected', 'true', 90);
    }
  
    get open() {
      return this.hasAttribute('open');
    }
  
    set open(val) {
      if(val) {
        this.setAttribute('open', '');
      }else {
        this.removeAttribute('open');
      }
    }
  
  }
  customElements.define('store-switcher', StoreSwitcher);
}

if (customElements.get('switcher-opener') === undefined) {
  class SwitcherOpener extends HTMLElement {
 
    constructor() {
      super();

    }

    connectedCallback() {
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('modal'));
        if (modal) modal.show(button);
      });
    }

    disconnectedCallback() {
    }

    attributeChangedCallback(name, oldVal, newVal) {

    }

    adoptedCallback() {
    }

  }
  customElements.define('switcher-opener', SwitcherOpener);
}

if (customElements.get('country-selector') === undefined) {
  class CountrySelector extends HTMLElement {
 
    constructor() {
      super();

    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.form.querySelector('input[name="country_code"]');
      this.links = this.querySelectorAll('a[data-country]');
      this.links.forEach((link) => {
        link.addEventListener('click', this.onGo.bind(this));
      });
    }

    disconnectedCallback() {
    }

    attributeChangedCallback(name, oldVal, newVal) {
    }

    adoptedCallback() {
    }

    setCookie(cName, cValue, expDays) {
      let date = new Date();
      date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = cName + "=" + cValue + "; " + expires + ";path=/;";
    }

    getCookie(name) {
      let value = "; " + document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    }

    onGo(event){
      event.preventDefault();
      const countryCode = event.currentTarget.dataset.country;
      this.input.value = countryCode;
      const url = new URL(event.currentTarget.href);
      url.searchParams.set('country', countryCode);
      url.searchParams.set('store-selected', '1');
      this.setCookie('store-selected', 'true', 90); 
      if(window.location.origin === url.origin){
        this.form.submit();
      }else{
        window.location.href = url.toString()
      }
    }

  }
  customElements.define('country-selector', CountrySelector);
}